import { styled, pulse } from '@showroomjs/ui';
import * as React from 'react';
import { usePropsEditorContext } from '../lib/use-props-editor';
import { PropsEditor } from './props-editor';
export const PropsEditorPanel = () => {
    const editor = usePropsEditorContext();
    return (React.createElement(Panel, { loading: !editor }, editor ? (React.createElement(PropsEditor, { editor: editor })) : (React.createElement(LoadingRoot, { "aria-hidden": true },
        React.createElement(LoadingLabel, { css: {
                width: 90,
            } }),
        React.createElement(Control, null),
        React.createElement(LoadingLabel, null),
        React.createElement(Control, { css: { maxWidth: '10rem' } }),
        React.createElement(LoadingLabel, { css: {
                width: 60,
            } }),
        React.createElement(Control, { css: {
                height: 90,
                maxWidth: 'none',
            } }),
        React.createElement(LoadingLabel, null),
        React.createElement(Control, null)))));
};
const Panel = styled('div', {
    px: '$2',
    py: '$4',
    variants: {
        loading: {
            true: {
                animation: `${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`,
            },
        },
    },
});
const LoadingRoot = styled('div', {
    display: 'grid',
    alignItems: 'center',
    py: '$1',
    gridTemplateColumns: 'max-content 1fr',
    columnGap: '$2',
    '@sm': {
        gap: '$2',
    },
});
const LoadingLabel = styled('div', {
    backgroundColor: '$gray-300',
    height: '1.5rem',
    width: '105px',
});
const LoadingControl = styled('div', {
    backgroundColor: '$gray-100',
    height: '2rem',
    width: '100%',
    maxWidth: '36rem',
    border: '1px solid $gray-300',
    borderRadius: '$base',
});
const ControlWrapper = styled('div', {
    '@sm': {
        px: '$2',
        py: '$1',
    },
});
const Control = styled(function Control(props) {
    return (React.createElement(ControlWrapper, null,
        React.createElement(LoadingControl, Object.assign({}, props))));
});
//# sourceMappingURL=props-editor-panel.js.map